import moment from "moment";

function getPercent(value, percent) {
  let percentSum = (value * percent) / 100;

  return Math.round(percentSum);
}

export default {
  eventPrice: (state) => {
    let price;

    if (state.currentEvent.discountMembersCount || state.currentEvent.discount || state.currentEvent.discountPromoSum || state.currentEvent.discountPromoPercent) {
      price = state.currentEvent.discountPrice
    } else {
      price = state.currentEvent.price
    }

    let eventPrice = price;

    if (state.partialPay.percent) {
      eventPrice = getPercent(price, state.partialPay.percent);
    }

    if (state.partialPay.sum <= eventPrice) {
        eventPrice = state.partialPay.sum;
    }

    return parseInt(eventPrice) || 0;
  },
  convertedPrice: (state, getters) => {
    if (!state.currentEvent) {
      return '';
    }

    let price;

    if (state.currentEvent.discountMembersCount || state.currentEvent.discount || state.currentEvent.discountPromoSum || state.currentEvent.discountPromoPercent) {
      price = state.currentEvent.discountPrice
    } else {
      price = state.currentEvent.price
    }

    let rate = 0;

    if (state.currentEvent.currency == 'eur') {
      rate = state.currentEvent.priceConverted / price;
    } else {
      rate = price / state.currentEvent.priceConverted;
    }

    let converted = state.currentEvent.currency == 'eur' ?
      getters.eventPrice * rate : getters.eventPrice / rate;

    return converted;
  },
  isPartialSum: (state) => {
    return (state.partialPay.percent > 0)
  },
  isAvailableFreePlaces: (state) => {
    let isAvailable = false;

    for(let event of state.events) {
      let eventStart = moment(event.date_start, 'DD.MM.YYYY').toDate();
      let currentStart = moment(state.currentEvent.date_start, 'DD.MM.YYYY').toDate();

      if (event.id !== state.currentEvent.id && eventStart >= currentStart && event.free_places > state.membersCount) {
        isAvailable = true;
      }
    }

    return isAvailable;
  },
  currencySymbol: (state) => {
    if (state.currentEvent.currency == 'rub') {
      return '<p class="rouble">&#8381;</p>';
    } else if (state.currentEvent.currency == 'eur') {
      return '<p class="euro">&#8364;</p>';
    } else {
      return '';
    }
  },
}
